module.exports = __webpack_public_path__ + "static/img/ruletka-off.06ee62bb.png";